// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore, setLogLevel } from "firebase/firestore"; // ⬅ add setLogLevel
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDKlKrIJ56vJECeM-x8bv0GcE9un2LUWgw",
  authDomain: "gtafanpage-8e42a.firebaseapp.com",
  projectId: "gtafanpage-8e42a",
  storageBucket: "gtafanpage-8e42a.firebasestorage.app",
  messagingSenderId: "494863412050",
  appId: "1:494863412050:web:32aeca8bd769fd9c61288b",
  measurementId: "G-2DQ2TBMFHB",
};

const app = initializeApp(firebaseConfig);

// -------- Firestore (with debug logs in dev) --------
const db = getFirestore(app);

// Enable verbose Firestore console logs *only* in development.
// You can also force it via env: VITE_FIRESTORE_LOG_LEVEL=debug
const FIRESTORE_LOG_LEVEL =
  import.meta?.env?.VITE_FIRESTORE_LOG_LEVEL ||
  (import.meta?.env?.MODE === "development" ? "debug" : "error");

try {
  // valid values: 'debug' | 'error' | 'silent'
  setLogLevel(FIRESTORE_LOG_LEVEL);
  if (FIRESTORE_LOG_LEVEL === "debug") {
    // Helpful breadcrumb so you know logs are on
    // This makes permission-denied / rules failures much easier to trace.
    console.info("[Firestore] log level:", FIRESTORE_LOG_LEVEL);
  }
} catch (e) {
  // If setLogLevel fails for any reason, don't block app startup
  console.warn("Failed to set Firestore log level:", e);
}

// -------- Auth --------
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// -------- Storage --------
const storage = getStorage(app);

// -------- Analytics (guarded) --------
let analytics = null;
isSupported()
  .then((yes) => {
    if (yes) {
      analytics = getAnalytics(app);
    }
  })
  .catch((e) => {
    // Some browsers/environments throw—ignore silently
    console.warn("Analytics not supported:", e?.message || e);
  });

export { app, auth, googleProvider, storage, db, analytics };
